import useSWR, { SWRResponse } from "swr";

import { useSWRApiErrorHandler } from "../common/hooks";
import { UserProfileRelationship } from "../types/relationship";
import { UserProfile } from "./profile";
import { RelationshipFormValues } from "../features/relationship/components/RelationshipForm"
import request, { ApiError } from "./common";

const path = "/user-profile-relationship";

const relationshipApi = {
    saveOrUpdate: (values: RelationshipFormValues): Promise<UserProfileRelationship> => {

        const contractorAccountNameList: UserProfile[] = values.contractorList.map((it) => {
            const profile = JSON.parse(it);
            return { ...profile }
        })
        const approverUserProfileList: UserProfile[] = values.approverList.map((it) => {
            const profile = JSON.parse(it);
            return { ...profile }
        })
        const payload: UserProfileRelationship = {
            developerUserProfile: JSON.parse(values.developer),
            contractorAccountNames: contractorAccountNameList.map((it) => it.accountName).join(";"),
            approverUserProfileId: approverUserProfileList.map((it) => it.id + "").join(";"),
            contractorAccountNameList: contractorAccountNameList,
            approverUserProfileList: approverUserProfileList,
        };
        if (values.id !== 0) {
            const updatePayload: UserProfileRelationship = {
                ...payload,
                id: values.id,
            };
            return request<UserProfileRelationship, UserProfileRelationship>(
                `${path}/updateRelationship`,
                "POST",
                updatePayload,
            );
        } else {
            return request<UserProfileRelationship, UserProfileRelationship>(
                `${path}/saveRelationship`,
                "POST",
                payload,
            );
        }
    },
    list: (): Promise<UserProfileRelationship[]> => {
        return request<UserProfileRelationship[]>(
            `${path}/maintenance-relationship`,
        );
    },
    listContractor: (): Promise<UserProfile[]> => {
        return request<UserProfile[]>(
            `${path}/listContractor`,
        );
    },
    listApprovers: (): Promise<UserProfile[]> => {
        return request<UserProfile[]>(
            `${path}/listApprovers`,
        );
    },
    immutableContractorList: (developerId: number): Promise<UserProfile[]> => {
        return request<UserProfile[]>(
            `${path}/getImmutable/contractor/${developerId}`,
        );
    },
    immutableApproverList: (developerId: number): Promise<UserProfile[]> => {
        return request<UserProfile[]>(
            `${path}/getImmutable/approver/${developerId}`,
        );
    },
};

export const useRelationshipList = (): SWRResponse<UserProfileRelationship[], ApiError> => {
    const onError = useSWRApiErrorHandler();
    return useSWR<UserProfileRelationship[], ApiError>(`${path}/maintenance-relationship`, request, {
        onError,
    });
};

export const useContractorList = (): SWRResponse<UserProfile[], ApiError> => {
    const onError = useSWRApiErrorHandler();
    return useSWR<UserProfile[], ApiError>(`${path}/listContractor`, request, {
        onError,
    });
};
export const useApproverList = (): SWRResponse<UserProfile[], ApiError> => {
    const onError = useSWRApiErrorHandler();
    return useSWR<UserProfile[], ApiError>(`${path}/listApprovers`, request, {
        onError,
    });
};

export default relationshipApi;
